<template>
  <div>
    <!-- tabs for mobile -->
    <div class="container article-list-button-wrapper" v-if="showCategories">
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
      <transition name="fade">
        <div class="article-list" v-if="showList">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li v-for="tab in tabs" :key="tab.id">
                <a @click="selectTab(tab)">{{tab.name}}</a>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>

    <!-- Agenda with tabs -->
    <div class="container main-content--tabbed" v-if="showCategories">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li v-for="(tab,index) in tabs" :key="tab.id">
                <a :class="{'active': $route.query.tab ? (tab.id === $route.query.tab) : index === 0}" @click="selectTab(tab)">
                  {{tab.name}}
                  <i class="icon-arrow"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 article-content">
          <HtmlContent :content="{contenthtml: selectedTab.value }" v-if="selectedTab.type===0"></HtmlContent>
          <template v-if="$store.getters.agendaAdditionalInformationLoaded">
            <SolutionGrid :boxes="content" v-if="selectedTab.type===6"></SolutionGrid>
            <FilesGrid :files="content" v-if="selectedTab.type===5"></FilesGrid>
          </template>
          <div class="agenda-section" v-if="contacts.length">
            <div class="main-content-bottom-title label">Contact</div>
            <div class="row boxes-row">
              <div class="col-lg-4" v-for="member in contacts" :key="member.idTeamMember">
                <TeamMemberBox :box="member" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Agenda without tabs -->
    <div class="container main-content" v-else>
      <div class="row">
        <HtmlContent :content="{contenthtml: selectedTab.value }" v-if="selectedTab.type===0"></HtmlContent>
        <template v-if="$store.getters.agendaAdditionalInformationLoaded">
          <SolutionGrid :boxes="content" v-if="selectedTab.type===6"></SolutionGrid>
          <FilesGrid :files="content" v-if="selectedTab.type===5"></FilesGrid>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlContent from "@/components/general/HtmlContent";
import SolutionGrid from "@/components/solutions/SolutionGrid";
import FilesGrid from "@/components/files/FilesGrid";
import TeamMemberBox from "@/components/persons/TeamMemberBox";
export default {
  name: "AgendaSingleAdditional",
  components: {TeamMemberBox, FilesGrid, SolutionGrid, HtmlContent},
  data () {
    return {
      showList: false,
      showCategories: true,
      tab: 1
    }
  },
  watch: {
    '$store.getters.agendaEventLoaded'(val) {
      if(val) {
        this.$store.getters.agendaEvent._embedded.AdditionalInformation.forEach((item) => {
          this.$store.dispatch('setAgendaAdditionalInformation', {type: item.intValue1, idSettingCompany: item.idSettingCompany})
        })
      }
    }
  },
  mounted() {
    if(this.$store.getters.agendaEventLoaded) {
      this.$store.getters.agendaEvent._embedded.AdditionalInformation.forEach((item) => {
        this.$store.dispatch('setAgendaAdditionalInformation', {type: item.intValue1, idSettingCompany: item.idSettingCompany})
      })
    }
  },
  computed: {
    contacts() {
      let contacts = this.$store.getters.settingsCompanyByParentId(this.selectedTab.id)
      if(contacts && contacts.length && this.$store.getters.teamMembersLoaded) {
        return this.$store.getters.teamMembers.filter((item) => {
          return contacts.map(item => item.value).includes(item.idTeamMember)
        })
      }
      return []
    },
    tabs() {
      let tabs = []
      this.$store.getters.agendaEvent._embedded.AdditionalInformation.forEach((item) => {
        tabs.push({
          name: item.valueDescription,
          id: item.idSettingCompany,
          code: item.settingTypeCode,
          type: item.intValue1,
          value: item.value
        })
      })
      return tabs
    },
    selectedTab() {
      let index = 0;
      if(this.$route.query.tab) {
        index = this.tabs.findIndex(item => {
          return item.id === this.$route.query.tab
        })
      }
      if(index === -1) index = 0

      if(this.tabs[index]) {
        return {...this.tabs[index]}
      } else {
        return {};
      }
    },
    content() {
      if(this.$store.getters.agendaAdditionalInformation) {
        return this.$store.getters.agendaAdditionalInformation[this.selectedTab.id]
      }
      return []
    }
  },
  methods: {
    selectTab(tab) {
      let query = {
        tab: tab.id,
      }
      this.$router.push({query})
    }
  }
}
</script>
